import case1 from '../assets/case/case-icon1.svg'
import case2 from '../assets/case/case-icon2.svg'
import case3 from '../assets/case/case-icon3.svg'
import case4 from '../assets/case/case-icon4.svg'
import case5 from '../assets/case/case-icon5.svg'
import CSK from '../assets/logos/CSK.svg';

/* Секция "Кейс" */
export function Case() {
    return (
        <section className="case" id="case">
            <div className="container">
                <h2 className="section-title scroll-reveal section-title--flex">
                    Кейс от компании <br />
                </h2>
                <div className="scroll-reveal">
                    <div className="case-upper">
                        <img
                            src={CSK}
                            alt="Energogarant"
                            className="section-title__logo"
                        />
                        <div className="case-options">
                            <div className="case-option">
                                <div>
                                    <img src={case1} alt="case1" />
                                </div>
                                <p>
                                    <span>
                                        ИИ-сервис для генерации изображений и анимаций на трибуны
                                    </span>
                                </p>
                            </div>
                            <div className="case-option">
                                <div>
                                    <img src={case2} alt="case1" />
                                </div>

                                <p>
                                    Это кейс на стыке <span>AI, digital product, fan engagement и event-технологий.
                                    ПФК ЦСКА</span> — один из ведущих футбольных клубов России с современной домашней ареной. Клуб активно развивает матчдэй-опыт и работу с болельщиками, поэтому заинтересован в технологичном решении, которое поможет создавать визуальные перформансы на трибунах и усиливать атмосферу домашних матчей.
                                </p>
                            </div>
                            <div className="case-option">
                                <div>
                                    <img src={case3} alt="case3" />
                                </div>

                                <p>
                                    Сервис поможет быстро готовить визуальные перформансы для трибун стадиона: статические изображения, пиксельные композиции и анимированные сцены, рассчитанные под реальную развертку мест.
                                </p>
                            </div>
                            <div className="case-option">
                                <div>
                                    <img src={case4} alt="case4" />
                                </div>

                                <p>
                                    Участникам нужно предложить решение, которое можно применять в реальном клубном контексте
                                </p>
                            </div>
                            <div className="case-option">
                                <div>
                                    <img src={case5} alt="case5" />
                                </div>
                                <p>
                                    В основе идеи — представить трибуну как большую пиксельную сетку, где <span>каждое место — это пиксель</span>, а итоговая картинка собирается из экранов телефонов болельщиков.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}